var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3468",
    "data-name": "Rectangle 3468",
    width: 16,
    height: 16,
    fill: "#8a8a8a",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(-11166 -1239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(11164.4 1238.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    d: "M9.6,8.533a3.807,3.807,0,0,0,3.467-3.694,3.512,3.512,0,0,0-.9-2.687A3.455,3.455,0,0,0,9.6,1.067,3.453,3.453,0,0,0,7.033,2.146a3.529,3.529,0,0,0-.9,2.693A3.8,3.8,0,0,0,9.6,8.533Z",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    d: "M16.513,14.659a5.706,5.706,0,0,0-2.54-3.792A7.947,7.947,0,0,0,9.6,9.6a7.95,7.95,0,0,0-4.373,1.267,5.706,5.706,0,0,0-2.54,3.792,1.179,1.179,0,0,0,.24.97A1.031,1.031,0,0,0,3.733,16H15.467a1.031,1.031,0,0,0,.807-.371,1.179,1.179,0,0,0,.239-.97Z",
    fill: "#8a8a8a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeller);
export default __webpack_public_path__ + "static/media/seller.b1c0b9e84be72147425eb155ed24218c.svg";
export { ForwardRef as ReactComponent };